const fields = [
    {name: 'delNomad', label: 'حذف عشایر'},
    {name: 'editNomad', label: 'ویرایش عشایر'},
    {name: 'addNomad', label: 'افزودن عشایر'},
    {name: 'delDriver', label: 'حذف راننده'},
    {name: 'editDriver', label: 'ویرایش راننده'},
    {name: 'addDriver', label: 'افزودن راننده'},
    {name: 'rejectReq', label: 'رد درخواست ها'},
    {name: 'manualDeliver', label: 'تایید تحویل دستی'},
    {name: 'addWaterReq', label: 'افزودن درخواست آب'},
    {name: 'getExcel', label: 'دریافت فایل اکسل'},
    {name: 'seeingReport', label: 'مشاهده گزارش گیری'},
    {name: 'delReq', label: 'حذف درخواست ها'},
];

const CheckboxesComponent = ({handleChange, formik}) => {
    return(
        <div className='checkboxes-part'>
            {fields.map((item, index) => {
                return(
                    <div key={index}>
                        <label>{item.label}</label>
                        <input type='checkbox' checked={formik.values.checked.includes(item.name)} name='checked' value={item.name} onChange={handleChange} />
                    </div>
                )
            })}

        </div>
    )
}

export default CheckboxesComponent